import * as moment from "moment";
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import {
  NgbDate,
  NgbCalendar,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Sort } from "@angular/material/sort";

@Component({
  selector: "app-taklist",
  templateUrl: "./taklist.component.html",
  styleUrls: ["./taklist.component.css"],
})
export class TaklistComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() clearEvent = new EventEmitter<void>();

  displayedColumns: string[] = [
    "TaskId",
    "ProjectName",
    "InquiryId",
    "TaskTitile",
    "TaskDiscription",
    "TaskStatus",
    "TaskPriority",
    "StartDate",
    "EndDate",
    "AssignedTo",
    "CreatedDate",
    "Createdby",
    "Action",
  ];

  sortData: any = { column: "ProjectName", direction: "asc" };
  userRId: any;
  Mpermission: any;

  disableDate() {
    return false;
  }
  dtOptions: any = {};
  dropdownTaskTitile: any = {};
  dropdownProject: any = {};
  dropdownTaskStatus: any = {};
  showTable: any = false;
  dropdownTaskPriority: any = {};
  dropdownSettings: any = {};
  dropdownAssignedTo: any = {};
  dropdownInquiry: any = {};
  TaskTitileArray: any = [];
  status: any;
  selecteddate_range: any[];
  selectedselect_date: any[];
  selecteddate_range2: any[];
  selectedselect_date2: any[];
  ProjectArray: any = [];
  TaskStatusArray: any = [];
  isValid: boolean = false;
  TaskPriorityArray: any = [];
  AssignedToArray: any = [];
  selectedInquiry: any = [];
  type: string;
  namesort: string;
  downicon: boolean = true;
  upicon: boolean = true;
  selectedstatusNameId: any;
  selectedstatus1NameId: string;
  dropdownList = [];
  selectedItems = [];
  dataSource: any;
  date_range: any = { startDate: moment, endDate: moment };
  date_range2: any = { startDate2: moment, endDate2: moment };
  date_range3: any = { startDate3: moment, endDate3: moment };
  start_date: string;
  end_date: string;
  start_date2: string;
  end_date2: string;
  timezone: any;
  contactListArray: any;
  totalSize: any = "";
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  columnsort: any;
  currentPage: any = 0;
  pageSize: any = 10;
  TotalRecord: any;
  dropdownList2 = [];
  selectedItems2 = [];
  dropdownSettings2 = {};
  resetPagination: boolean = false;
  dropdownList3 = [];
  selectedItems3 = [];
  dropdownSettings3 = {};
  dropdownList4 = [];
  selectedItems4 = [];
  dropdownSettings4 = {};
  dropdownList5 = [];
  selectedItems5 = [];
  dropdownSettings5 = {};
  dropdownList6 = [];
  selectedItems6 = [];
  dropdownSettings6 = {};
  dropdownList7 = [];
  selectedItems7 = [];
  dropdownSettings7 = {};
  activitytype: any = "activity";
  isCollapsed: any;
  searchword: any;

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, "days"),
    moment().add(3, "days"),
    moment().add(5, "days"),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, "day"));
  };

  deleteId: any;
  file: any;
  delstatus: any;
  err_message: any;
  modalRef: any;
  colorpriority: any = [];
  userid: any;
  AssignedToName: any;
  permission: any = [];

  constructor(
    calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private router: Router,
    private UserService: UserService,
    private spinner: NgxSpinnerService,
    private changeDetectorRefs: ChangeDetectorRef,
    private modalService: BsModalService,
    private formBuilder: FormBuilder
  ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
  }

  registerForm = this.formBuilder.group({
    ProjectName: [""],
    InquiryName: [""],
    Taskitile: [""],
    TaskStatus: [""],
    StartDate: [""],
    CheckStart: [false],
    CheckEnd: [false],
    CheckCreate: [false],
    EndDate: [""],
    StartDate2: [""],
    EndDate2: [""],
    StartDate3: [""],
    EndDate3: [""],
    AssignedToUserName: [""],
    Task_Followers: [""],
    TaskPriorityName: [""],
    TaskDescription: [""],
    Remark: [""],
    ActionTaken: [""],
    OutcomeRemark: [""],
  });

  ngOnInit(): void {
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);

    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);

    let userid = localStorage.getItem("userId");
    this.userid = this.UserService.decryptData(userid);

    this.date_range.startDate = "";
    this.date_range.endDate = "";
    this.date_range.startDate2 = "";
    this.date_range.endDate2 = "";
    this.date_range.startDate3 = "";
    this.date_range.endDate3 = "";
    this.taskTitle();
    this.TaskStatus();
    this.TaskPriority();
    this.AssignedTo();
    this.Project();
    this.InquiryID();
    this.Inquiryname();

    this.dropdownTaskTitile = {
      text: "Task Titile",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownTaskStatus = {
      text: "Task Status",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownTaskPriority = {
      text: "Task Priority",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownAssignedTo = {
      text: "Assigned To",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownProject = {
      text: "Project",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    this.dropdownInquiry = {
      text: "Inquiry ",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    let data = {
      SearchWord: this.searchword,
      ProjectId: "",
      InquiryId: "",
      TaskStatus: "",
      TaskPriority: "",
      TaskTitle: "",
      assignto: "",
      StartDate: "",
      EndDate: "",
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      ED_StartDate: "",
      ItemPerPages: this.pageSize,
      ED_EndDate: "",
      CD_StartDate: "",
      CD_EndDate: "",
      IsStartDate: false,
      IsEndDate: false,
      IsCreatedDate: false,
      Status: "1,2",
    };
    this.spinner.show();
    this.UserService.TaskListFilter(data).subscribe(
      (res) => {
        if (res["result"] == "success") {
          this.spinner.hide();
          this.currentPage = 0;
          this.contactListArray = res["ContactList"];
          this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
          this.dataSource.paginator = this.paginator;
          this.totalSize = res["TotalRecord"];
          this.TotalRecord = res["TotalRecord"];
          this.iterator();
          this.resetPagination = true;
        } else if (res["result"] == "Failed") {
          this.toastr.error(res["Msg"]);
          this.spinner.hide();
        } else {
          this.toastr.error(res["Msg"] || res["Message"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastr.error(err.Msg || err.Message);
        }
      }
    );

    this.isCollapsed = false;
    this.activitytype = "activity";
    this.start_date = "";
    this.end_date = "";
    this.timezone = "";

    this.dropdownList = [
      { id: 13, itemName: "Hamad Hospital" },
      { id: 14, itemName: "Borosilicate- U trap	" },
      { id: 15, itemName: "Farzana project" },
    ];

    this.selectedItems = [
      { id: 13, itemName: "Hamad Hospital" },
      { id: 14, itemName: "Borosilicate- U trap	" },
      { id: 15, itemName: "Farzana project" },
    ];

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    //multiselect dropdown2

    this.dropdownList2 = [
      { id: 13, itemName: "IQTR22EQU01 " },
      { id: 14, itemName: "IQTR22EQU02" },
    ];

    this.selectedItems2 = [
      { id: 13, itemName: "IQTR22EQU01 " },
      { id: 14, itemName: "IQTR22EQU02" },
    ];

    this.dropdownSettings2 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    //multiselect dropdown3

    this.dropdownList3 = [
      { id: 13, itemName: "Task-1 " },
      { id: 14, itemName: "Task-2" },
    ];

    this.selectedItems3 = [
      { id: 13, itemName: "Task-1 " },
      { id: 14, itemName: "Task-2" },
    ];

    this.dropdownSettings3 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    //multiselect dropdown4

    this.dropdownList4 = [
      { id: 13, itemName: "Task-Priority 1" },
      { id: 14, itemName: "Task-Priority 2" },
    ];

    this.selectedItems4 = [
      { id: 13, itemName: "Task-Priority 1" },
      { id: 14, itemName: "Task-Priority 2" },
    ];

    this.dropdownSettings4 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    //multiselect dropdown5

    this.dropdownList5 = [
      { id: 13, itemName: "Ashish" },
      { id: 14, itemName: "Vishesh" },
    ];

    this.selectedItems5 = [
      { id: 13, itemName: "Ashish" },
      { id: 14, itemName: "Vishesh" },
    ];

    this.dropdownSettings5 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    //multiselect dropdown6

    this.dropdownList6 = [
      { id: 13, itemName: "Task-Title 1" },
      { id: 14, itemName: "Task-Title 2" },
    ];

    this.selectedItems6 = [
      { id: 13, itemName: "Task-Title 1" },
      { id: 14, itemName: "Task-Title 2" },
    ];

    this.dropdownSettings6 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };

    this.dropdownList7 = [
      { id: 51, itemName: "Start Date" },
      { id: 52, itemName: "End Date" },
      { id: 53, itemName: "Created Date" },
    ];

    this.selectedItems7 = [];

    this.dropdownSettings7 = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: "1",
    };
  }

  TaskTitile1: any = [];
  taskTitle() {
    let data = {};
    this.UserService.TaskTitle(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskTitileArray = res;
        this.TaskTitile1 = [];
        for (const data of this.TaskTitileArray["Data"]) {
          this.TaskTitile1.push({
            id: data["TaskTitleId"],
            itemName: data["Name"],
          });
        }
      } else {
        this.TaskTitileArray = [];
      }
    });
  }
  selectedTitle: any = [];
  selectedTitleName: any = "";
  selectedTitleNameId: string = "";
  onTitleSelect(item: any) {
    this.selectedTitleName = "";
    this.selectedTitleNameId = "";
    this.selectedTitle.forEach((element) => {
      this.selectedTitleName += element["itemName"] + ", ";
      this.selectedTitleNameId += element["id"] + ",";
    });
  }

  TaskStatus1: any = [];
  TaskStatus() {
    let data = {};
    this.UserService.TaskStatus(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskStatusArray = res;
        this.TaskStatus1 = [];
        for (const data of this.TaskStatusArray["Data"]) {
          this.TaskStatus1.push({
            id: data["TaskStatusId"],
            itemName: data["Name"],
          });
        }
      } else {
        this.TaskStatusArray = [];
      }
    });
  }
  selectedStatus: any = [];
  selectedStatusName: any = "";
  selectedStatusNameId: string = "";
  onStatusSelect(item: any) {
    this.selectedStatusName = "";
    this.selectedStatusNameId = "";
    this.selectedStatus.forEach((element) => {
      this.selectedStatusName += element["itemName"] + ", ";
      this.selectedStatusNameId += element["id"] + ", ";
    });
  }

  TaskPriority1: any = [];
  TaskPriority() {
    let data = {};
    this.UserService.TaskPriority(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskPriorityArray = res;
        this.TaskPriority1 = [];
        for (const data of this.TaskPriorityArray["Data"]) {
          this.TaskPriority1.push({
            id: data["TaskPriorityId"],
            itemName: data["Name"],
          });
          this.colorpriority = data["ColourCode"];
        }
      } else {
        this.TaskPriorityArray = [];
      }
    });
  }
  selectedPriority: any = [];
  selectedPriorityName: any = "";
  selectedPriorityNameId: string = "";
  onPrioritySelect(item: any) {
    this.selectedPriorityName = "";
    this.selectedPriorityNameId = "";
    this.selectedPriority.forEach((element) => {
      this.selectedPriorityName += element["itemName"] + ", ";
      this.selectedPriorityNameId += element["id"] + ", ";
    });
  }

  AssignedTo1: any = [];
  AssignedTo() {
    let data = {};
    this.UserService.GetAllUser(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.AssignedToArray = res;
        for (const data of this.AssignedToArray["Data"]) {
          this.AssignedTo1.push({
            id: data["UserId"],
            itemName: data["UserName"],
          });
        }
      } else {
        this.AssignedToArray = [];
      }
    });
  }
  selectedAssignedTo: any = [];
  selectedAssignedToName: any = "";
  selectedAssignedTo1NameId: string = "";
  onAssignedToSelect(item: any) {
    this.selectedAssignedToName = "";
    this.selectedAssignedTo1NameId = "";
    this.selectedAssignedTo.forEach((element) => {
      this.selectedAssignedToName += element["itemName"] + ", ";
      this.selectedAssignedTo1NameId += element["id"] + ", ";
    });
  }

  Project1: any = [];
  Project() {
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ProjectArray = res;
        for (const data of this.ProjectArray["Data"]) {
          this.Project1.push({
            id: data["ProjectId"],
            itemName: `${data["ProjectName"]} (${data["ProjectNumber"]})`,
            Status: data["Status"],
          });
        }
      } else {
        this.ProjectArray = [];
      }
    });
  }
  selectedProject: any = [];
  selectedProjectName: any = "";
  selectedProjectNameId: string = "";
  onProject(item: any) {
    this.selectedProjectName = "";
    this.selectedProjectNameId = "";
    this.selectedstatus1NameId = item.Status + "";
    this.selectedProject.forEach((element) => {
      this.selectedProjectName += element["itemName"] + ", ";
      this.selectedProjectNameId += element["id"] + ", ";
    });
    this.getinquiirybyproject(
      this.selectedProjectNameId,
      this.selectedstatus1NameId
    );
  }

  InquiryArray: any = [];
  InquiryList: any = [];
  getinquiirybyproject(id, Status) {
    let data = {
      ProjectId: id,
      Status: Status,
    };
    this.UserService.GetInqueryListByProjectId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.InquiryArray = res;
        for (const data of this.InquiryArray["Data"]) {
          this.InquiryList.push({
            id: data["InquiryId"],
            itemName: data["InquiryName"],
          });
        }
      } else {
        this.InquiryList = [];
      }
    });
  }
  selectedInquiryName: any = "";
  selectedInquiryId: any = "";
  onInquirySelect(item: any) {
    this.selectedInquiryName = "";
    this.selectedInquiryId = "";
    this.selectedInquiry.forEach((element) => {
      this.selectedInquiryName += element["itemName"];
      this.selectedInquiryId += element["id"];
    });
  }

  InquiryID1: any = [];
  InquiryID() {
    let data = {};
    this.UserService.GetInqueryListByProjectId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TaskPriorityArray = res;
        for (const data of this.TaskPriorityArray["Data"]) {
          this.InquiryID1.push({
            id: data["TaskPriorityId"],
            itemName: data["Name"],
          });
        }
      } else {
        this.TaskPriorityArray = [];
      }
    });
  }

  InquiryId: any = [];
  Inquiryname() {
    let data = {};
    this.UserService.GetInquiryNumber(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.InquiryArray = res;
        for (const data of this.InquiryArray["Data"]) {
          this.InquiryId.push({
            id: data["InquiryId"],
            itemName: `${data["InquiryName"]} (${data["InquiryNumber"]})`,
          });
        }
      } else {
        this.InquiryArray = [];
      }
    });
  }
  selectedInquiryId3: any = [];
  selectedInquiryId3Name: any = "";
  selectedInquiry3NameId: string = "";
  onInquiryIdSelect(item: any) {
    this.selectedInquiryId3Name = "";
    this.selectedInquiry3NameId = "";
    this.selectedInquiryId3.forEach((element) => {
      this.selectedInquiryId3Name += element["itemName"] + ", ";
      this.selectedInquiry3NameId += element["id"] + ", ";
    });
  }

  onSelectAll(items: any) {}
  onDeSelectAll(items: any) {}

  openClosefun() {
    this.isCollapsed = !this.isCollapsed;
  }

  changeActivityType(type) {
    this.activitytype = type;
  }

  public handlePage(e: any) {
    this.spinner.show();
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.iterator();
    let data = {
      SearchWord: this.searchword,
      ProjectId: this.selectedProjectNameId,
      InquiryId: this.selectedInquiry3NameId,
      TaskStatus: this.selectedStatusNameId,
      TaskPriority: this.selectedPriorityNameId,
      TaskTitle: this.selectedTitleNameId,
      assignto: this.selectedAssignedTo1NameId,
      SD_StartDate: "",
      SD_EndDate: "",
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      ED_StartDate: "",
      ItemPerPages: this.pageSize,
      ED_EndDate: "",
      CD_StartDate: "",
      CD_EndDate: "",
      IsStartDate: false,
      IsEndDate: false,
      IsCreatedDate: false,
      Status: "1,2",
    };
    this.UserService.TaskListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.totalSize = this.TotalRecord;
      }
    });
  }

  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.contactListArray.slice(start, end);
    this.dataSource = part;
  }

  edit(id) {
    let encryptid = this.UserService.encryptData(id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/Task/EditTask", encryptid]);
  }

  view(eid) {
    if (this.permission.Task_View == 1 || this.userRId == 1) {
      let encryptid = this.UserService.encryptData(eid);
      encryptid = encryptid
        .toString()
        .replace("=", "Ar1t")
        .replace("/", "FGH")
        .replace("+", "THD");
      this.router.navigate(["/Task/DetailTask", encryptid]);
    } else {
      this.toastr.error("Permission Denied !");
    }
  }

  onSortData(sort: Sort) {
    this.currentPage = 0;
    this.spinner.show();
    this.changeDetectorRefs.detectChanges();
    this.sortData = [];
    this.sortData = { column: sort.active, direction: sort.direction };
    this.type = sort.direction;
    this.namesort = sort.active;
    if (sort.direction == "asc") {
      this.upicon = true;
      this.downicon = false;
    } else {
      this.upicon = false;
      this.downicon = true;
    }
    this.columnsort = sort.active;
    let data = {
      SearchWord: this.searchword,
      ProjectId: this.selectedProjectNameId,
      InquiryId: this.selectedInquiry3NameId,
      TaskStatus: this.selectedStatusNameId,
      TaskPriority: this.selectedPriorityNameId,
      TaskTitle: this.selectedTitleNameId,
      assignto: this.selectedAssignedTo1NameId,
      SD_StartDate: "",
      SD_EndDate: "",
      PageNo: this.currentPage + 1,
      Sort: sort.active,
      SortWise: sort.direction,
      ED_StartDate: "",
      ItemPerPages: this.pageSize,
      ED_EndDate: "",
      CD_StartDate: "",
      CD_EndDate: "",
      IsStartDate: false,
      IsEndDate: false,
      IsCreatedDate: false,
      Status: "1,2",
    };
    this.dataSource = [];
    this.UserService.TaskListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.TotalRecord = res["TotalRecord"];
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.totalSize = this.TotalRecord;
      }
    });
  }

  applyFilter() {
    this.spinner.show();
    this.currentPage = 0;
    let data = {
      SearchWord: this.searchword,
      ProjectId: this.selectedProjectNameId,
      InquiryId: this.selectedInquiry3NameId,
      TaskStatus: this.selectedStatusNameId,
      TaskPriority: this.selectedPriorityNameId,
      TaskTitle: this.selectedTitleNameId,
      assignto: this.selectedAssignedTo1NameId,
      SD_StartDate: "",
      SD_EndDate: "",
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      ED_StartDate: "",
      ItemPerPages: this.pageSize,
      ED_EndDate: "",
      CD_StartDate: "",
      CD_EndDate: "",
      IsStartDate: false,
      IsEndDate: false,
      IsCreatedDate: false,
      Status: "1,2",
    };
    this.UserService.TaskListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.TotalRecord = res["TotalRecord"];
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.totalSize = this.TotalRecord;
      }
    });
  }

  clearUserData() {
    const previousValue = this.searchword;
    this.searchword = "";
    if (
      previousValue &&
      previousValue.length > 0 &&
      previousValue !== this.searchword
    ) {
      this.clearEvent.emit();
    }
  }

  tr: any;
  onSubmit() {
    let start, end, start2, end2, start3, end3;
    this.showTable = false;
    this.spinner.show();
    this.currentPage = 0;
    if (this.registerForm.value.CheckStart) {
      if (
        this.date_range.startDate &&
        this.date_range.startDate != "" &&
        this.date_range.endDate &&
        this.date_range.endDate != ""
      ) {
        start = this.datePipe.transform(
          this.date_range.startDate,
          "yyyy-MM-dd"
        );
        end = this.datePipe.transform(this.date_range.endDate, "yyyy-MM-dd");
      } else {
        start = "";
        end = "";
      }
    }
    if (this.registerForm.value.CheckEnd) {
      if (
        this.date_range2.startDate &&
        this.date_range2.startDate != "" &&
        this.date_range2.endDate &&
        this.date_range2.endDate != ""
      ) {
        start2 = this.datePipe.transform(
          this.date_range2.startDate,
          "yyyy-MM-dd"
        );
        end2 = this.datePipe.transform(this.date_range2.endDate, "yyyy-MM-dd");
      } else {
        start2 = "";
        end2 = "";
      }
    }
    if (this.registerForm.value.CheckCreate) {
      if (
        this.date_range3.startDate &&
        this.date_range3.startDate != "" &&
        this.date_range3.endDate &&
        this.date_range3.endDate != ""
      ) {
        start3 = this.datePipe.transform(
          this.date_range3.startDate,
          "yyyy-MM-dd"
        );
        end3 = this.datePipe.transform(this.date_range3.endDate, "yyyy-MM-dd");
      } else {
        start3 = "";
        end3 = "";
      }
    }
    this.status = Array.prototype.map
      .call(this.selectedItems5, function (item) {
        return item.id;
      })
      .join(",");
    let data = {
      SearchWord: this.searchword,
      ProjectId: this.selectedProjectNameId,
      InquiryId: this.selectedInquiry3NameId,
      TaskStatus: this.selectedStatusNameId,
      TaskPriority: this.selectedPriorityNameId,
      TaskTitle: this.selectedTitleNameId,
      AssignedTo: this.selectedAssignedTo1NameId,
      SD_StartDate: start,
      SD_EndDate: end,
      PageNo: this.currentPage + 1,
      Sort: "",
      SortWise: "",
      ED_StartDate: start2,
      ItemPerPages: this.pageSize,
      ED_EndDate: end2,
      CD_StartDate: start3,
      CD_EndDate: end3,
      IsStartDate: false,
      IsEndDate: false,
      IsCreatedDate: false,
      Status: "1,2,",
    };
    this.resetPagination = false;
    this.UserService.TaskListFilter(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.spinner.hide();
        this.showTable = true;
        this.dataSource = new MatTableDataSource<any>(res["ContactList"]);
        this.TotalRecord = res["TotalRecord"];
        this.tr = res["TotalRecord"];
        this.totalSize = this.TotalRecord;
        this.router.navigate(["/Task/TaskList"]);
      } else if (res["result"] == "Failed") {
        this.toastr.error(res["Msg"]);
        this.spinner.hide();
      } else {
        this.toastr.error(res["Msg"] || res["Message"]);
        this.spinner.hide();
      }
    });
  }

  resetData() {
    this.selectedProjectNameId = "";
    this.selectedInquiryId = "";
    this.selectedStatusNameId = "";
    this.selectedPriorityNameId = "";
    this.selectedAssignedTo1NameId = "";
    this.selectedTitleNameId = "";
    this.selectedselect_date = [];
    this.selecteddate_range = [];
    this.registerForm.reset();
    this.totalSize = this.tr;
    this.ngOnInit();
    this.isCollapsed = true;
  }

  deleteOpenModal(template: TemplateRef<any>, data, id) {
    if (data) {
      this.deleteId = data.TaskId;
      this.file = data.TaskNumber;
      this.delstatus = id;
      this.modalRef = this.modalService.show(template, {
        class: "modal-sm modal-dialog-centered",
      });
    }
  }

  decline() {
    this.isValid = false;
    this.modalRef.hide();
  }

  deleteConfirm() {
    this.deleteTask();
    this.modalRef.hide();
  }

  deleteTask() {
    this.spinner.show();
    this.UserService.UpdateTaskStatus({
      TaskId: this.deleteId,
      Status: this.delstatus,
    }).subscribe((response: any) => {
      if (response["result"] == "success") {
        this.spinner.hide();
        this.toastr.success("Task Deleted Successfully!");
        this.router
          .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl("/Task/TaskList");
          });
      } else {
        this.err_message = response.Msg;
      }
    });
  }
}
